module.exports = __webpack_public_path__ + "img/43.e8dbed0b.png";